import { ViewModel } from './model';
import html from './template.html';
import './style.less';

ko.components.register('svg-icon', {
  viewModel: {
    createViewModel: (params, componentInfo) => {
      let element = componentInfo.element;
      element.classList.add('svg-icon');

      return new ViewModel(params, element);
    }
  },
  template: html
});
